(function () {
  'use strict';

  // Only run on touch/coarse-pointer devices (mobile & tablet)
  if (!window.matchMedia('(pointer: coarse)').matches) return;

  var SWIPE_THRESHOLD = 40; // px to commit to next/prev slide
  var SNAP_DURATION = '0.3s';

  function initCard(card) {
    var mediaLink = card.querySelector('.product-card__media');
    if (!mediaLink) return;

    var track = mediaLink.querySelector('.product-card__swipe-track');
    if (!track) return;

    // All direct-child images are slides (primary first, then swipe images)
    var slides = Array.from(track.children);
    if (slides.length < 2) return;

    var dots = Array.from(card.querySelectorAll('.product-card__swipe-dot'));
    var total = slides.length;
    var currentIndex = 0;
    var slideWidth = 0;

    var touchStartX = 0;
    var touchStartY = 0;
    var isHorizontal = false;
    var wasSwiped = false;

    function getSlideWidth() {
      return track.offsetWidth;
    }

    function setOffset(px, animate) {
      track.style.transition = animate ? ('transform ' + SNAP_DURATION + ' ease') : 'none';
      track.style.transform = 'translateX(' + px + 'px)';
    }

    function goTo(index, animate) {
      slideWidth = getSlideWidth();
      setOffset(-index * slideWidth, animate);
      currentIndex = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    mediaLink.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isHorizontal = false;
      wasSwiped = false;
      slideWidth = getSlideWidth();
      // Kill any running snap transition so the track follows the finger instantly
      track.style.transition = 'none';
    }, { passive: true });

    mediaLink.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      // Determine axis on first significant move
      if (!isHorizontal && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
      if (!isHorizontal) {
        isHorizontal = Math.abs(dx) >= Math.abs(dy);
      }

      if (isHorizontal) {
        e.preventDefault();
        // Rubber-band resistance at the first and last slide
        var raw = dx;
        if ((currentIndex === 0 && dx > 0) || (currentIndex === total - 1 && dx < 0)) {
          raw = dx * 0.25;
        }
        track.style.transform = 'translateX(' + (-currentIndex * slideWidth + raw) + 'px)';
      }
    }, { passive: false });

    mediaLink.addEventListener('touchend', function (e) {
      if (!isHorizontal) return;

      var dx = e.changedTouches[0].clientX - touchStartX;

      if (Math.abs(dx) >= SWIPE_THRESHOLD) {
        if (dx < 0 && currentIndex < total - 1) {
          goTo(currentIndex + 1, true);
          wasSwiped = true;
        } else if (dx > 0 && currentIndex > 0) {
          goTo(currentIndex - 1, true);
          wasSwiped = true;
        } else {
          goTo(currentIndex, true); // rubber-band back
        }
      } else {
        goTo(currentIndex, true); // snap back
      }
    }, { passive: true });

    // Prevent <a> navigation when the gesture was a swipe
    mediaLink.addEventListener('click', function (e) {
      if (wasSwiped) {
        e.preventDefault();
        wasSwiped = false;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('product-card').forEach(initCard);
  }

  // Handle cards injected later (infinite scroll, quick-buy reload, etc.)
  function observeMutations() {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('product-card')) {
            initCard(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('product-card').forEach(initCard);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      observeMutations();
    });
  } else {
    initAll();
    observeMutations();
  }
}());
